import { Injectable, NgZone }     from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';

import {TrackerService} from './tracker';
import {SecretService} from './secret';
import {PlatformService} from './platform.service';

declare let window: any;

export const LOCAL_STORAGE_KEY = 'github_token';

const BASE_URL = 'https://api.github.com';
const REDIRECT_URI = window.config.github.redirect_uri;
const GITHUB_CLIENT_ID = window.config.github.client_id;
const WORKFLOW_DIRECTORY = window.config.workflowDirectory || 'workflows'

@Injectable()
export class GitHubService {
  access_token: string;
  scopes: string[]=[];
  user: any;
  onAuthFinished: any;
  oauthURL: string;

  loading:boolean;
  forkWorkflows:any[];
  pullRequests:any[] = [];

  constructor(private http:HttpClient,
              private zone:NgZone,
              private tracker:TrackerService,
              private platformService: PlatformService,
              private secrets:SecretService) {
    window.githubService = this;
    this.oauthURL = "https://github.com/login/oauth/authorize";
    this.oauthURL += "?client_id=" + GITHUB_CLIENT_ID;
    this.oauthURL += "&redirect_uri=" + encodeURIComponent(REDIRECT_URI);
    this.oauthURL += '&prompt=select_account';
    this.oauthURL += '&scope=user:email,public_repo';
    this.setPullRequests();
    this.checkAuth();
  }

  buildSearch(params={}) {
    let search = new HttpParams();
    for (var k in params) search = search.set(k, params[k]);
    if (this.access_token) {
      search = search.set('access_token', this.access_token);
    }
    return search;
  }

  get(url, params={}) {
    return this.setUpRequest(this.http.get(BASE_URL + url, {params: this.buildSearch(params)}))
  }

  putOrPost(method, url, body={}, query={}) {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let params = this.buildSearch(query);
    return this.setUpRequest(this.http[method](BASE_URL + url, JSON.stringify(body), { headers, params }));
  }

  post(url, body={}, query={}) {
    return this.putOrPost('post', url, body, query);
  }
  put(url, body={}, query={}) {
    return this.putOrPost('put', url, body, query);
  }

  setUpRequest(req) {
    this.loading = true;
    return req.toPromise()
        .then(res => {
          this.loading = false;
          return res;
        })
        .catch(this.handleError)
  }

  authorize(callback=null) {
    this.onAuthFinished = callback;
    this.secrets.onOAuthFinished = (qs) => this.oauthCallback(qs);
    window.open(this.oauthURL, '_blank');
  }

  oauthCallback(qs) {
    if (this.platformService.isServer) return;
    if (qs.error) return
    window.jQuery.ajax({
      method: 'POST',
      url: window.config.github.access_token_url + '?code=' + qs.code,
      headers: {'Content-Type': 'application/json'},
    }).done((data) => {
      window.localStorage.setItem(LOCAL_STORAGE_KEY, data.access_token);
      this.checkAuth();
    }).fail((xhr) => {
      console.log('oauth failure', xhr.responseText);
    });
  }

  logout() {
    if (this.platformService.isServer) return;
    window.localStorage.setItem(LOCAL_STORAGE_KEY, '');
    this.checkAuth();
  }

  checkAuth() {
    if (this.platformService.isServer) return;
    this.zone.run(() => {
      this.access_token = window.localStorage.getItem(LOCAL_STORAGE_KEY);
      this.user = null;
      if (!this.access_token) return;
      this.get('/user')
        .then(data => {
          this.user = data;
        })
        .then(() => {
          if (this.onAuthFinished) this.onAuthFinished();
          this.onAuthFinished = null;
        })
    });
  }

  setForkWorkflows(forkName) {
    this.get('/repos/' + forkName)
      .then(repo => {
        return this.get('/repos/' + forkName + '/contents/' + WORKFLOW_DIRECTORY)
      })
      .then(contents => {
        this.forkWorkflows = contents.map(c => c.name);
      });
  }

  setPullRequests() {
    this.get('/repos/' + window.config.github.repo + '/pulls')
      .then(pulls => this.pullRequests = pulls.filter(p => p.head.repo));
  }

  getWorkflowPreviewURL(forkName, workflowName) {
    return `https://raw.githubusercontent.com/${forkName}/master/${WORKFLOW_DIRECTORY}/${workflowName}/readme.md`
  }

  private handleError (error: any) {
    let errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error(errMsg);
    return Promise.reject(errMsg);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/github.ts